<template>
  <div class="availability-area">
    <div class="container mw-1780">
      <div class="availability-wrap">
        <div class="row align-items-center">
          <!-- الطرف الأيسر: نص تشجيعي -->
          <div
            class="col-lg-6"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="100"
          >
            <div class="availability-content">
              <h3>تريد تجربة السيرفر قبل الاشتراك؟ نوفر لك تجربة مجانية!</h3>
              <div class="d-sm-flex align-items-center">
                <span class="d-block mt-2 mt-sm-0">
                  تواصل معنا الآن واحصل على خطة تجريبية مجانية تماماً للتأكد من الجودة والثبات.
                </span>
              </div>
            </div>
          </div>

          <!-- الطرف الأيمن: زر الواتساب المباشر والنص المناسب -->
          <div
            class="col-lg-6"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div class="availability-form text-center text-lg-end">
              <p class="mb-3 fs-5 fw-bold text-white">اضغط على الزر أدناه لبدء التجربة الفورية:</p>
              
              <a 
                href="https://wa.me/447429916178" 
                target="_blank" 
                class="btn active d-inline-flex align-items-center justify-content-center px-5 py-3 w-100 position-relative"
                style="background-color: #25D366; border-color: #25D366; color: #fff; font-size: 18px;"
              >
                <i class="ti ti-brand-whatsapp me-2 fs-4"></i>
                <span class="border-style">اطلب تجربتك المجانية عبر الواتساب</span>
              </a>

              <p class="text-body mt-3 mb-0">
                لديك اشتراك بالفعل؟ 
                <RouterLink to="/contact-us">تواصل معنا لتجديد اشتراكك.</RouterLink>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "StreetAddressesApartments",
});
</script>